import { render, staticRenderFns } from "./CameraControls.vue?vue&type=template&id=c7d3f0ec"
import script from "./CameraControls.vue?vue&type=script&lang=js"
export * from "./CameraControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports